import React from 'react';
import { Field } from 'redux-form';
// @material-ui/icons
import Face from '@material-ui/icons/Face';
import RecordVoiceOver from '@material-ui/icons/RecordVoiceOver';
import Email from '@material-ui/icons/Email';
import Phone from '@material-ui/icons/Phone';
import Lock from '@material-ui/icons/LockOutlined';

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import InputAdornment from '@material-ui/core/InputAdornment';

// core components
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import { REFERRER_DETAIL_INFO_PATH } from 'constants/paths';
import { PASSWORD_MIN, PASSWORD_MAX, NAME_MIN, NAME_MAX, PHONE_MIN, PHONE_MAX } from 'constants/inputBounds';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import CustomInput from 'components/CustomInput/CustomInput.jsx';
import familyImage from '../../../../assets/images/Gfx-Handshake.svg';


const style = {
  infoText: {
    fontWeight: '300',
    margin: '10px 0 30px',
    textAlign: 'center'
  },
  inputAdornmentIcon: {
    color: '#555'
  },
  inputAdornment: {
    position: 'relative'
  },
  flatImage: {
    width: '80%',
    maxWidth: '450px',
    marginTop: '3rem',
    height: 'auto',
    margin: 'auto',
    marginLeft: '12%'
  },
  girdItemPadding: {
    paddingLeft: 60,
    paddingRight: 60
  },
  textCenterH1: {
    textAlign: 'center',
    maxWidth: 300,
    margin: 'auto',
    marginBottom: 45
  },
  textCenterH1Right: {
    textAlign: 'center',
    maxWidth: 300,
    margin: 'auto',
    marginBottom: 65
  },
  textCenterP: {
    textAlign: 'center',
    maxWidth: 260,
    margin: 'auto'
  },
  anchorButton: {
    textDecoration: 'none',
    alignSelf: 'center',
    padding: 0,
    textTransform: 'none',
    minHeight: 0,
    marginTop: -1,
    minWidth: 37,
    color: '#2b81e0'
  }
};

class Step1 extends React.Component {
  constructor(props) {
    super(props);
    //console.log(props);
    this.state = {
      firstname: '',
      firstnameState: '',
      lastname: '',
      lastnameState: '',
      email: '',
      emailState: '',
      phone: '',
      phoneState: '',
      passwordState: ''
    };
  }
  sendState() {
    return this.state;
  }
  // function that returns true if value is email, false otherwise
  verifyEmail(value) {
    var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRex.test(value)) {
      return true;
    }
    return false;
  }

  // Verify Correctly that input is made of digits only
  verifyDigit(value) {
    if (isNaN(value)) {
      return false;
    }
    return true;
  }

  // Verify Correct Length of custom input
  verifyLength(value, minLength, maxLength) {
    if (value.length >= minLength && value.length <= maxLength) {
      return true;
    }
    return false;
  }

  change(event, stateName, type, stateNameEqualTo, stateNameMax) {
    switch (type) {
      case 'email':
        if (this.verifyEmail(event.target.value)) {
          this.setState({ [stateName + 'State']: 'success' });
        } else {
          this.setState({ [stateName + 'State']: 'error' });
        }
        break;
      case 'length':
        if (this.verifyLength(event.target.value, stateNameEqualTo, stateNameMax)) {
          this.setState({ [stateName + 'State']: 'success' });
        } else {
          this.setState({ [stateName + 'State']: 'error' });
        }
        break;
      case 'digit':
        if (
          this.verifyDigit(event.target.value) &&
          this.verifyLength(event.target.value, stateNameEqualTo, stateNameMax)
        ) {
          this.setState({ [stateName + 'State']: 'success' });
        } else {
          this.setState({ [stateName + 'State']: 'error' });
        }
      default:
        break;
    }
    this.setState({ [stateName]: event.target.value });
  }
  isValidated() {
    return true;
    if (
      this.state.firstnameState === 'success' &&
      this.state.lastnameState === 'success' &&
      this.state.emailState === 'success' &&
      this.state.phoneState === 'success' &&
      this.state.passwordState === 'success'
    ) {
      return true;
    } else {
      if (this.state.firstnameState !== 'success') {
        this.setState({ firstnameState: 'error' });
      }
      if (this.state.lastnameState !== 'success') {
        this.setState({ lastnameState: 'error' });
      }
      if (this.state.emailState !== 'success') {
        this.setState({ emailState: 'error' });
      }
      if (this.state.phoneState !== 'success') {
        this.setState({ phoneState: 'error' });
      }
      if (this.state.passwordState !== 'success') {
        this.setState({ passwordState: 'error' });
      }
    }
    return false;
  }
  render() {
    const { classes } = this.props;
    const { organisation } = this.props;
    
    return (
      <GridContainer justify="center">
        <GridItem xs={12} sm={6}>
          <h1 className={classes.textCenterH1}>Referrer Program {organisation}</h1>
          <p className={classes.textCenterP}>
            A quick, simple and easy process to refer your clients. See more details click 
            <a
              style={{ marginTop: '2rem', marginLeft:'.2rem' }}
              href='https://www.my-tribe.com.au/referrers'
              target='_blank'
              rel="noopener noreferrer"
            >
              here
            </a>
            .
          </p>
          <img className={classes.flatImage} src={familyImage} alt="" />
        </GridItem>
        <GridItem xs={12} sm={6} className={classes.girdItemPadding}>
          <h1 className={classes.textCenterH1Right}>Your Details</h1>
          <CustomInput
            success={this.state.firstnameState === 'success'}
            error={this.state.firstnameState === 'error'}
            labelText={
              <span>
                First Name <small>(required)</small>
              </span>
            }
            id="firstname"
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              onChange: event => this.change(event, 'firstname', 'length', NAME_MIN, NAME_MAX),
              startAdornment: (
                <InputAdornment position="start" className={classes.inputAdornment}>
                  <Face className={classes.inputAdornmentIcon} />
                </InputAdornment>
              )
            }}
          />
          <CustomInput
            success={this.state.lastnameState === 'success'}
            error={this.state.lastnameState === 'error'}
            labelText={
              <span>
                Last Name <small>(required)</small>
              </span>
            }
            id="lastname"
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              onChange: event => this.change(event, 'lastname', 'length', NAME_MIN, NAME_MAX),
              startAdornment: (
                <InputAdornment position="start" className={classes.inputAdornment}>
                  <RecordVoiceOver className={classes.inputAdornmentIcon} />
                </InputAdornment>
              )
            }}
          />
          <CustomInput
            success={this.state.emailState === 'success'}
            error={this.state.emailState === 'error'}
            labelText={
              <span>
                Email <small>(required)</small>
              </span>
            }
            id="email"
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              onChange: event => this.change(event, 'email', 'email'),
              startAdornment: (
                <InputAdornment position="start" className={classes.inputAdornment}>
                  <Email className={classes.inputAdornmentIcon} />
                </InputAdornment>
              )
            }}
          />

          <CustomInput
            success={this.state.phoneState === 'success'}
            error={this.state.phoneState === 'error'}
            labelText={
              <span>
                Phone <small>(required)</small>
              </span>
            }
            id="email"
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              onChange: event => this.change(event, 'phone', 'digit', PHONE_MIN, PHONE_MAX),
              startAdornment: (
                <InputAdornment position="start" className={classes.inputAdornment}>
                  <Phone className={classes.inputAdornmentIcon} />
                </InputAdornment>
              )
            }}
          />

          <CustomInput
            success={this.state.passwordState === 'success'}
            error={this.state.passwordState === 'error'}
            labelText={
              <span>
                Password <small>(required)</small>
              </span>
            }
            id="password"
            type="password"
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              type: 'password',
              onChange: event => this.change(event, 'password', 'length', PASSWORD_MIN, PASSWORD_MAX),
              startAdornment: (
                <InputAdornment position="start" className={classes.inputAdornment}>
                  <Lock className={classes.inputAdornmentIcon} />
                </InputAdornment>
              )
            }}
          />
        </GridItem>
      </GridContainer>
    );
  }
}

export default withStyles(style)(Step1);
